export function redirect(url: string, { replace = false }: { replace?: boolean } = {}) {
	if (replace) {
		window.location.replace(url);
	}
	else {
		window.location.href = url;
	}
}
